import { BasicsClass } from "@/common/BasicsClass";

export class MerchantWithdrawAddAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getShopWithdrawAddLists', {
      url: '/admin/shopWithdraw/addLists',
      name: 'list',
      label: '列表'
    }],
    ['addShopWithdraw', {
      url: '/admin/shopWithdraw/add',
      name: 'add',
      label: '增加'
    }],
    ['searchVenueList', {
      url: '/admin/coupons/shop/list',
      name: 'shop-list',
      label: '店铺列表',
      // hidden: true
    }],
  ])
  // 订单api 方法
  // 商家提现余额扣款记录列表
  public getShopWithdrawAddLists(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls
    const url = apiUrls.get('getShopWithdrawAddLists').url
    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  public addShopWithdraw(
      params: any,
      successCb: Function,
      failCb: Function,
      showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls
    const url = apiUrls.get('addShopWithdraw').url
    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 搜索店铺列表
  public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('searchVenueList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
}
}
